<!--
 * @Author: your name
 * @Date: 2020-01-03 17:55:02
 * @LastEditTime : 2020-01-08 09:20:57
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \official-website-huaruan\src\components\Footer.vue
 -->
<template>
  <div id="footer" class="container-fluid">
    <div class="footer-wrap">
      <div class="left">
        <div class="left-top">
          <div class="mouseOver" @click="goMenu('/home')">首页</div>
          <div class="mouseOver" @click="goMenu('/aboutUs')">关于我们</div>
          <div class="mouseOver" @click="goMenu('/workShopLogin')">
            工厂登录
          </div>
        </div>
        <div class="left-bottom">
          <span class="left-bottom-span1">Copyright © 2025 苏州巨象信息技术有限公司 版权所有</span>
          <span class="left-bottom-span2" @click="goPath()">
            苏ICP备2021005570号-1</span>
        </div>
      </div>
      <div class="mid">
        <div class="mid-left">
          <img src="@/assets/img/logo_jx.png" />
          <div class="mid-bottom">
            <img src="@/assets/img/phone.png" />
            <span>+86 181 1553 3390</span>
          </div>
        </div>
        <div class="mid-right">
          <div class="right">
            <img src="@/assets/img/jx-logo.jpg" />
            <div class="right-tips">扫一扫，关注巨象</div>
          </div>
        </div>
        <!-- <img src="@/assets/img/logo_jx.png" />
      <div class="mid-bottom">
        <img src="@/assets/img/phone.png" />
        <span>+86 181 1553 3390</span>
      </div> -->
      </div>
      <!-- <div class="right">
         <img src="@/assets/img/jx-logo.jpg" />
         <div class="right-tips">扫一扫，关注巨象</div>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  methods: {
    // 跳转网站备案
    goPath() {
      window.open("https://beian.miit.gov.cn/#/Integrated/index", "_blank");
    },
    // 跳转菜单
    goMenu(path) {
      if (this.$route.path == path) {
        return;
      }
      if (path == "/workShopLogin") {
        window.open("https://juxiangshare.com/workshop/login", "_blank");
        return;
      }
      this.$router.push({ path: path });
    },
  },
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  background: #f7f7f7;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
}

.footer-wrap {
  width: 1200px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 43px 0 43px 0;
}

.footer-wrap .left {
  /* width: 549px; */
  /* display: flex;
  flex-direction: column;
  justify-content: space-between; */
  flex: 1;
  padding-right: 0px;
}

.footer-wrap .left .left-top {
  display: flex;
  justify-content: space-between;
  color: #333333;
  font-size: 20px;
  font-weight: 600 !important;
}

.left-bottom {
  margin-top: 46px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left-bottom .left-bottom-span1 {
  font-size: 16px;
  color: #888888;
  text-align: center;
}

.left-bottom .left-bottom-span2 {
  font-size: 16px;
  color: #bbbbbb;
  cursor: pointer;
}

.footer-wrap .mid {
  margin-top: -20px;
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  /* padding-left: 50px; */
}

.mid-left {
  margin-right: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.footer-wrap .mid-left img {
  width: 138px;
  height: 57px;
}

.footer-wrap .mid .mid-bottom {
  display: flex;
  align-items: center;
  margin-top: 37px;
}

.footer-wrap .mid .mid-bottom img {
  width: 25px;
  height: 24px;
}

.footer-wrap .mid .mid-bottom span {
  margin-left: 5px;
  font-size: 24px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 33px;
}

.footer-wrap .right {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  flex-direction: column;
  flex: 1;
}

.footer-wrap .right .right-tips {
  margin-top: 10px;
  width: 150px;
  text-align: center;
}

.footer-wrap .right img {
  width: 150px;
  height: 150px;
}

.footer-wrap .right span {
  margin-top: 19px;
  font-size: 14px;
  color: #888888;
}

.mouseOver {
  cursor: pointer;
}

@media screen and (min-width: 0) and (max-width: 1200px) {
  .footer-wrap {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column-reverse;
    padding: 43px 0 43px 0;
  }

  .footer-wrap .left .left-top {
    display: flex;
    justify-content: space-between;
    color: #333333;
    font-size: 20px;
    font-weight: 600 !important;
    display: none;
  }

  .footer-wrap .mid-left {
    display: none;
    margin-right: 0px;
  }

  .footer-wrap .mid {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-direction: column;
  }

  .left-bottom {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column-reverse;
  }

  .footer-wrap .mid-left img {
    width: 138px;
    height: 57px;
  }

  .footer-wrap .mid-right img {
    width: 138px;
    height: 138px;
  }

  .footer-wrap .mid .mid-bottom {
    display: flex;
    align-items: center;
    margin-top: 0;
  }

  .footer-wrap .mid .mid-bottom img {
    width: 20px;
    height: 20px;

  }

  .footer-wrap .mid {
    margin-top: 10px;
  }

  .footer-wrap .mid .mid-bottom span {
    font-size: 18px;
  }

  .left-bottom .left-bottom-span1 {
    font-size: 14px;
  }

  .left-bottom .left-bottom-span2 {
    font-size: 14px;
  }

  .left-bottom {
    margin-top: 10px;
  }

  .mid-right {
    margin-top: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue